import { reactive } from 'vue';

const eventHandlers = reactive(new Map());

export const EventBus = {
  $emit(eventName, ...args) {
    if (eventHandlers.has(eventName)) {
      eventHandlers.get(eventName).forEach((callback) => callback(...args));
    }
  },
  $on(eventName, callback) {
    if (!eventHandlers.has(eventName)) {
      eventHandlers.set(eventName, []);
    }
    eventHandlers.get(eventName).push(callback);
  },
  $off(eventName, callback) {
    if (eventHandlers.has(eventName)) {
      const handlers = eventHandlers.get(eventName).filter((cb) => cb !== callback);
      if (handlers.length > 0) {
        eventHandlers.set(eventName, handlers);
      } else {
        eventHandlers.delete(eventName);
      }
    }
  }
};